let currentPage = jQuery('#blogCards').data('current-page');
let maxPages = jQuery('#blogCards').data('max-pages');
let ajaxUrl = jQuery('#blogCards').data('ajax-url');

function loadMorePosts() {
    const categoryId = jQuery('#blogCards').data('category-id');
    const currentLang = jQuery('#blogCards').data('current-lang'); // Получаем текущий язык

    currentPage++;
    if (currentPage <= maxPages) {
        jQuery.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'load_more_posts',
                page: currentPage,
                category_id: categoryId,
                lang: currentLang // Передаем язык в запрос
            },
            beforeSend: function () {
                jQuery('#load-more-btn').prop('disabled', true);
            },
            success: function (response) {
                jQuery('.posts-container').append(response);
                jQuery('#load-more-btn').prop('disabled', false);

                // Обновляем пагинацию после добавления постов
                updatePaginationLinks();

                if (currentPage <= 1) {
                    jQuery('#prev-page').hide(); // Скрыть кнопку "Prev" на первой странице
                } else {
                    jQuery('#prev-page').show(); // Показывать кнопку "Prev" на всех остальных страницах
                }

                // Скрываем кнопку "Next", если на последней странице
                if (currentPage >= maxPages) {
                    jQuery('#next-page').hide();
                    jQuery('#load-more-btn').hide(); // Если достигли последней страницы, скрываем кнопку "Загрузить больше"
                } else {
                    jQuery('#next-page').show();
                    jQuery('#load-more-btn').show();
                }
            },
        });
    } else {
        jQuery('#load-more-btn').hide();
    }
}


function updatePagination(page) {
    const categoryId = jQuery('#blogCards').data('category-id');
    const currentLang = jQuery('#blogCards').data('current-lang'); // Получаем текущий язык

    jQuery.ajax({
        url: ajaxUrl,
        type: 'POST',
        data: {
            action: 'load_posts_page',
            page: page,
            category_id: categoryId,
            lang: currentLang // Передаем язык в запрос
        },
        beforeSend: function () {
            jQuery('.posts-container').empty();
            jQuery('#load-more-btn').show();
        },
        success: function (response) {
            jQuery('.posts-container').html(response);
            currentPage = page;
            updatePaginationLinks();

            // Скрываем кнопку "Prev", если на первой странице
            if (currentPage <= 1) {
                jQuery('#prev-page').hide(); // Скрыть кнопку "Prev" на первой странице
            } else {
                jQuery('#prev-page').show(); // Показывать кнопку "Prev" на всех остальных страницах
            }

            // Скрываем кнопку "Next", если на последней странице
            if (currentPage >= maxPages) {
                jQuery('#next-page').hide();
                jQuery('#load-more-btn').hide(); // Если достигли последней страницы, скрываем кнопку "Загрузить больше"
            } else {
                jQuery('#next-page').show();
                jQuery('#load-more-btn').show();
            }
        },
    });
}

// Начальная проверка для кнопок "Prev" и "Next"
jQuery(document).ready(function () {
    // Проверка текущей страницы и установка видимости кнопок "Prev" и "Next"
    if (currentPage <= 1) {
        jQuery('#prev-page').hide(); // Скрыть кнопку "Prev", если на первой странице
    } else {
        jQuery('#prev-page').show(); // Показывать кнопку "Prev", если не на первой
    }

    if (currentPage >= maxPages) {
        jQuery('#next-page').hide(); // Скрыть кнопку "Next", если на последней странице
        jQuery('#load-more-btn').hide(); // Если последняя страница, скрыть кнопку "Загрузить больше"
    } else {
        jQuery('#next-page').show(); // Показывать кнопку "Next", если не на последней
        jQuery('#load-more-btn').show(); // Показывать кнопку "Загрузить больше"
    }
});


function updatePaginationLinks() {
    let paginationHTML = '';
    for (let i = 1; i <= maxPages; i++) {
        paginationHTML += `<li class="pagination__item  ${i == currentPage ? 'pagination__item--active' : ''}"><a href="javascript:void(0);" class="pagination-link" data-page="${i}">${i}</a></li>`;
    }
    jQuery('#pgb').html(paginationHTML);
    jQuery('.pagination-link').click(function (e) {
        e.preventDefault();
        let page = jQuery(this).data('page');
        if (page != currentPage) {
            updatePagination(page);
        }
    });
}

jQuery('#load-more-btn').click(loadMorePosts);
updatePaginationLinks();

jQuery('#prev-page').click(function (e) {
    e.preventDefault();
    if (currentPage > 1) {
        updatePagination(currentPage - 1); // Переход на предыдущую страницу
    }
});

jQuery('#next-page').click(function (e) {
    e.preventDefault();
    if (currentPage < maxPages) {
        updatePagination(currentPage + 1); // Переход на следующую страницу
    }
});
